import React, { useEffect } from 'react';
import { useFormikContext } from 'formik';
import { Button, FormControl, FormHelperText, InputLabel, MenuItem, Select, SelectChangeEvent } from '@mui/material';
import { GenericObject } from '@fnol/library/src/lib/consts';
import { prepareRisksList } from '../../lib/helpers';
import { personType, policiesProperties, translations } from '../../lib/consts';
import { ClaimDetailsCleanup } from '../ClaimDetailScreen/ClaimDetailScreen';
import { IndividualCleanup } from '../Individual/Individual';
import { LegalEntityCleanup } from '../LegalEntity/LegalEntity';

const SelectRisk = () => {
    const { values, touched, errors, setFieldValue } = useFormikContext<GenericObject>();
    const [showSelect, setShowSelect] = React.useState(false);
    useEffect(() => {
        setFieldValue('risksList', prepareRisksList(values.activePolicy[policiesProperties.risks]));
    }, [values.activePolicy]);

    const clearUsersTable = () => {
        values.usersFromTable?.map((user: GenericObject) => {
            IndividualCleanup(personType.user, setFieldValue, user.editId);
        });
    };

    const handleChangeRisk = (e: any) => {
        if (e.target.value.length > 0) {
            const risksValues = e.target.value.filter((id: any) => id !== undefined);
            // setFieldValue('risks', typeof e.target.value === 'string' ? e.target.value.split(',') : e.target.value);
            setFieldValue('risks', risksValues);

            setFieldValue(
                'riskNames',
                values.risksList
                    .filter((risk: GenericObject) => risksValues.includes(risk.id))
                    .map((riskName: GenericObject) => {
                        const riskNamesArray = [];
                        riskNamesArray.push(riskName.text);
                        return riskNamesArray.join(', ');
                    }),
            );

            setFieldValue(
                'selectedRisks',
                values.risksList
                    ?.filter((risk: GenericObject) => risksValues.includes(risk.id))
                    .map((risk: GenericObject) => risk),
            );

            setFieldValue('agreementDataForContract', false);
            setFieldValue('agreementObligation', false);
            setFieldValue('submitterRole', '');
        } else {
            setFieldValue('risks', []);
            setFieldValue('riskNames', '');
            setFieldValue('selectedRisks', []);
        }

        clearUsersTable();
        IndividualCleanup(personType.user, setFieldValue);
        LegalEntityCleanup(personType.user, setFieldValue);

        ClaimDetailsCleanup(setFieldValue);
    };

    const handleDisabled = (riskGroup: string) => {
        let isDisabled = true;
        if (values.risks?.length === 0) {
            isDisabled = false;
        } else {
            const selectedRisks = values.risksList
                ?.filter((risk: GenericObject) => values.risks.includes(risk.id))
                .map((risk: GenericObject) => risk);

            selectedRisks.map((risk: GenericObject) => {
                if (riskGroup === risk.group) {
                    isDisabled = false;
                }
            });
        }
        return isDisabled;
    };

    return (
        <FormControl error={!!(touched.risks && errors.risks)} required>
            <InputLabel id="risks">{translations.RISK_LABEL}</InputLabel>
            <Select
                name="risks"
                label={translations.RISK_LABEL}
                multiple
                open={showSelect}
                onOpen={() => setShowSelect(true)}
                onClose={() => setShowSelect(false)}
                value={values.risks}
                onChange={handleChangeRisk}
            >
                <Button
                    sx={{
                        display: 'block',
                        minWidth: 'auto',
                        margin: '0 8px 8px auto',
                        padding: '0 10px',
                    }}
                    color="primary"
                    variant="contained"
                    onClick={() => {
                        setShowSelect(false);
                    }}
                >
                    <span style={{ fontSize: '18px' }}>&#10003;</span>
                </Button>
                {values.risksList?.map((risk: GenericObject) => {
                    return (
                        <MenuItem key={risk.id} value={risk.id} disabled={handleDisabled(risk.group)}>
                            {risk?.text}
                        </MenuItem>
                    );
                })}
            </Select>
            {touched.risks && errors.risks ? (
                <FormHelperText error={true}>
                    <>{errors.risks}</>
                </FormHelperText>
            ) : null}
        </FormControl>
    );
};

export default SelectRisk;
